// Data table card component for displaying report options
// Provides clickable cards for different data reports and analytics

import React from "react";
import {
    Box,
    Flex,
    Text,
    Icon,
    useColorModeValue,
    Button
} from "@chakra-ui/react";
import Card from "components/card/Card";

const DataTableCard = ({ title, description, icon, color = "blue", onClick, buttonText = "צפה בדוח" }) => {
    const textColor = useColorModeValue("secondaryGray.900", "white");
    const textColorSecondary = useColorModeValue("secondaryGray.600", "secondaryGray.300");
    const brandColor = useColorModeValue(`${color}.500`, `${color}.400`);
    const bg = useColorModeValue("white", "navy.700");
    const hoverBg = useColorModeValue("gray.50", "navy.600");

    return (
        <Card
            bg={bg}
            p="20px"
            cursor="pointer"
            transition="all 0.2s"
            _hover={{
                bg: hoverBg,
                transform: "translateY(-2px)",
                boxShadow: "lg"
            }}
            onClick={onClick}
        >
            <Flex direction="column" h="100%">
                <Flex align="center" mb="16px">
                    <Flex
                        align="center"
                        justify="center"
                        w="56px"
                        h="56px"
                        borderRadius="16px"
                        bg={`${color}.100`}
                        me="16px"
                    >
                        <Icon
                            as={icon}
                            w="28px"
                            h="28px"
                            color={brandColor}
                        />
                    </Flex>
                    <Box flex="1">
                        <Text
                            color={textColor}
                            fontSize="lg"
                            fontWeight="bold"
                            mb="4px"
                        >
                            {title}
                        </Text>
                    </Box>
                </Flex>
                
                <Text
                    color={textColorSecondary}
                    fontSize="sm"
                    mb="20px"
                    flex="1"
                >
                    {description}
                </Text>
                
                <Button
                    variant="outline"
                    colorScheme={color}
                    size="sm"
                    w="100%"
                    onClick={(e) => {
                        e.stopPropagation();
                        onClick();
                    }}
                >
                    {buttonText}
                </Button>
            </Flex>
        </Card>
    );
};

export default DataTableCard;
